module.exports = __webpack_public_path__ + "static/media/transfer.027e47f5.svg";